/**
 * package: com.inq.stage
 * class: ViewportMgrImplTablet
 * @extends com.inq.stage.ViewportMgrImplMobile
 * @constructor
 */
com.inq.stage.ViewportMgrImplTablet = function() {
	com.inq.stage.ViewportMgrImplMobile.call(this);
	if(this.clientViewportElement == null) {
		this.createViewportElement("");
		this.RestoreViewport();
	}
};
/* specify hierary; its parent is com.inq.stage.ViewportMgrImplPhone */
$hxClasses.extend(com.inq.stage.ViewportMgrImplMobile, com.inq.stage.ViewportMgrImplTablet, 'com.inq.stage.ViewportMgrImplTablet');

/**
 * @override
 */
com.inq.stage.ViewportMgrImplTablet.prototype.hide = function() {
	if(this.isShown === true) {
		this.isShown = false;
	}
};

/**
 * @override
 */
com.inq.stage.ViewportMgrImplTablet.prototype.show = function() {
	if(this.isShown !== true) {
		this.isShown = true;
	}
};

/** @type {com.inq.stage.ViewportMgrImplTablet} */
com.inq.stage.ViewportMgrImplTablet.prototype.__class__ = com.inq.stage.ViewportMgrImplTablet;
